<cipo-dialog-header title="formulas.title" />

<mat-dialog-content>
    <div fxLayout="column" fxLayoutGap="16px">
        <div class="m-t formula-input" [class.error-highlight]="formulaError && formulaErrorPosition">
            <mat-form-field class="form-field">
                <input
                    #formulaInput
                    matInput
                    [placeholder]="'formulas.formula' | translate"
                    [matAutocomplete]="auto"
                    autocomplete="off"
                    [formControl]="formulaControl"
                    [textHighlight]="formulaHighlightRules()"
                    (input)="clearErrorHighlight(); onFormulaInputEvent($event)"
                    (click)="onFormulaInputEvent($event)"
                    (keyup)="onFormulaInputEvent($event)"
                    (focus)="onFormulaInputEvent($event)" />
                <button
                    mat-icon-button
                    matSuffix
                    (click)="clearFormula()"
                    [attr.aria-label]="'formulas.labels.clearFormula' | translate">
                    <mat-icon>close</mat-icon>
                </button>
                <mat-autocomplete
                    #auto="matAutocomplete"
                    (optionSelected)="onFieldOptionSelected($event)"
                    [displayWith]="displayFn"
                    autoActiveFirstOption="false"
                    [disableRipple]="true">
                    @for (option of getFilteredFields(); track option) {
                        <mat-option [value]="option">
                            <div class="autocomplete-option">
                                <span class="field-name">{{ option.label }}</span>
                                <span class="field-meta field-meta-flex">
                                    @if (option.isContractField) {
                                        <span class="moduleNameWrapper">
                                            {{ "formulas.labels.contract" | translate }}
                                        </span>
                                    }
                                    @if (option.type) {
                                        <span class="fieldRestrictionWrapper">{{ option.type }}</span>
                                    }
                                </span>
                            </div>
                        </mat-option>
                    }
                    @for (option of getFilteredOperators(); track option) {
                        <mat-option [value]="option">
                            <div class="autocomplete-option">
                                <span class="field-name">{{ option.value }}</span>
                            </div>
                        </mat-option>
                    }
                </mat-autocomplete>
                <mat-hint align="end">
                    {{ "formulas.labels.cursorPosition" | translate }} {{ displayCursorPosition }}/{{
                        formulaControl.value?.length || 0
                    }}
                </mat-hint>
            </mat-form-field>
        </div>
        <div>
            <button mat-raised-button color="primary" (click)="validate()" class="validate-button">
                {{ "formulas.validateFormula" | translate }}
            </button>
            <button mat-raised-button color="accent" (click)="testFormula()" class="test-button">
                {{ "formulas.testFormula" | translate }}
            </button>
        </div>
        @if (formulaError) {
            <div
                class="cipo-text--warn-500 cipo--text-size--sm"
                fxLayout
                fxLayoutAlign="start center"
                fxLayoutGap="8px">
                <mat-icon class="cipo-icon cipo-icon--sm">error_outline</mat-icon>
                <span>{{ formulaError }}</span>
                @if (formulaErrorPosition && formulaErrorPosition.start !== undefined) {
                    <span class="error-position">
                        {{ "formulas.labels.position" | translate }} {{ formulaErrorPosition.start + 1 }}
                        @if (
                            formulaErrorPosition.end !== undefined &&
                            formulaErrorPosition.end !== formulaErrorPosition.start + 1
                        ) {
                            - {{ formulaErrorPosition.end }}
                        }
                    </span>
                }
            </div>
        }
        @if (formulaSuccess) {
            <div class="cipo-text--accent-700">
                {{ formulaSuccess }}
            </div>
        }
        <div fxLayout="row" fxLayoutGap="12px">
            <div fxFlex class="fields-container">
                <mat-form-field class="search-field">
                    <input
                        matInput
                        [placeholder]="'formulas.labels.fields' | translate"
                        [formControl]="fieldSearchControl" />
                    <mat-icon matSuffix class="search-icon">search</mat-icon>
                </mat-form-field>
                <div class="fields-list">
                    <mat-list>
                        @for (field of filteredFields(); track field; let last = $last) {
                            <mat-list-item>
                                <div class="field-display">
                                    <span class="field-name">{{ field.label }}</span>
                                    <span class="field-meta field-meta-flex">
                                        @if (field.isContractField) {
                                            <span class="moduleNameWrapper">
                                                {{ "formulas.labels.contract" | translate }}
                                            </span>
                                        }
                                        @if (field.type) {
                                            <span class="fieldRestrictionWrapper">{{ field.type }}</span>
                                        }
                                    </span>
                                </div>
                                <button
                                    mat-icon-button
                                    (click)="insertIntoFormula(field)"
                                    [attr.aria-label]="'a11y.common.add' | translate">
                                    <mat-icon class="cipo-icon cipo-icon--md" aria-hidden="true">add</mat-icon>
                                </button>
                            </mat-list-item>
                            @if (!last) {
                                <mat-divider></mat-divider>
                            }
                        }
                    </mat-list>
                </div>
            </div>
            <div fxFlex class="operators-container">
                <mat-form-field class="search-field">
                    <input
                        matInput
                        [placeholder]="'formulas.labels.operators' | translate"
                        [formControl]="operatorSearchControl" />
                    <mat-icon matSuffix class="search-icon">search</mat-icon>
                </mat-form-field>
                <div class="operators-scroll">
                    @for (group of filteredOperatorGroups(); track group.category) {
                        <div class="operator-group-row">
                            <div class="operator-group-title">
                                <strong>{{ group.category | translate }}</strong>
                            </div>
                            <mat-accordion>
                                @for (op of group.items; track op) {
                                    <mat-expansion-panel>
                                        <mat-expansion-panel-header>
                                            <mat-panel-title>
                                                <span class="operator-title-compact">{{ op.value }}</span>
                                                <button
                                                    mat-icon-button
                                                    [attr.aria-label]="'a11y.common.add' | translate"
                                                    (click)="insertOperatorAndStopPropagation(op.value, $event)">
                                                    <mat-icon class="cipo-icon cipo-icon--md" aria-hidden="true">
                                                        add
                                                    </mat-icon>
                                                </button>
                                            </mat-panel-title>
                                        </mat-expansion-panel-header>
                                        <div class="operator-details">
                                            @if (getOperationDefinition(op)?.description) {
                                                <div>
                                                    {{ "formulas.labels.description" | translate }}
                                                    {{ getOperationDefinition(op)?.description | translate }}
                                                </div>
                                            }
                                            @if (getOperationDefinition(op)?.example) {
                                                <div>
                                                    {{ "formulas.labels.example" | translate }}
                                                    <code>{{ getOperationDefinition(op)?.example }}</code>
                                                </div>
                                            }
                                            @if (getOperationDefinition(op)?.syntax) {
                                                <div>
                                                    {{ "formulas.labels.syntax" | translate }}
                                                    <code>{{ getOperationDefinition(op)?.syntax }}</code>
                                                </div>
                                            }
                                        </div>
                                    </mat-expansion-panel>
                                }
                            </mat-accordion>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">{{ "formulas.cancel" | translate }}</button>
    <button mat-raised-button color="primary" [disabled]="!isFormulaValid()" (click)="useFormula()">
        {{ "formulas.useFormula" | translate }}
    </button>
</mat-dialog-actions>
